import React from "react";
import Banner from "../Components/Banner";
import Card from "../Components/UI/Card";

import About from "./About";

const Home = ({ homeElement }) => {
  return (
    // <div className="p-2 md:p-4 md:pl-[17rem] h-[calc(100vh-4rem)] overflow-scroll">
    <div className="p-2 md:p-4 md:pl-[17rem] h-[calc(100vh-4rem)] pt-[6rem] overflow-scroll ">
      <Banner homeElement={homeElement} />

      <Card>
        <div className="p-8 mt-4 rounded-lg bg-slate-900">
          <p className="text-justify">
            I am an enthusiastic and passionate 𝐅𝐫𝐨𝐧𝐭-𝐞𝐧𝐝 𝐃𝐞𝐯𝐞𝐥𝐨𝐩𝐞𝐫, driven to
            excel in the field. who is excited about creating visually pleasing
            and 𝐮𝐬𝐞𝐫-𝐟𝐫𝐢𝐞𝐧𝐝𝐥𝐲 𝐰𝐞𝐛 𝐚𝐩𝐩𝐬. With my strong skills in 𝐇𝐓𝐌𝐋, 𝐂𝐒𝐒,
            𝐉𝐚𝐯𝐚𝐒𝐜𝐫𝐢𝐩𝐭, 𝐚𝐧𝐝 𝐑𝐞𝐚𝐜𝐭, I can easily make designs come to life in a
            visually pleasing and practical way. I am eager to work with a
            creative and forward-thinking team to make a positive difference in
            the world of 𝐰𝐞𝐛 𝐝𝐞𝐯𝐞𝐥𝐨𝐩𝐦𝐞𝐧𝐭.
          </p>
        </div>
      </Card>
      <About />
    </div>
  );
};

export default Home;
